module.exports = __webpack_public_path__ + "img/src/components/ContactForm/mailblack.svg?1eaeffa7";